import {Button} from '@hm/fundamental'
import {AssetConfigurationDto} from '@kilnfeature/types'
import {useMemo} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {DrillingPositions} from './DrillingPositions'
import {DrillingZones} from './DrillingZones'

import {useEditDrillingSettings} from '@refra/modules/refra-planning/hooks/mutations'
import {
  DrillingPosition,
  DrillingSettingsDTO,
  DrillingZone
} from '@refra/modules/refra-planning/types'

const DEFAULT_START = 0

export const DrillingSettings = ({
  drillingSettings,
  kilnConfig
}: {
  drillingSettings: DrillingSettingsDTO
  kilnConfig: AssetConfigurationDto
}) => {
  const {t} = useTranslation()
  const kilnLength = Number(kilnConfig.payload.configuration.dimensions.length)
  const {mutate} = useEditDrillingSettings()

  const defaultDrillingZones = useMemo(
    () => [
      {
        name: '',
        fromMeter: DEFAULT_START,
        toMeter: kilnLength,
        threshold: DEFAULT_START
      }
    ],
    [kilnLength]
  )

  const methods = useForm<{drillingZones: DrillingZone[]; drillingPositions: DrillingPosition[]}>({
    defaultValues: {
      drillingPositions: drillingSettings.drillingPositions,
      drillingZones: drillingSettings.drillingZones.length
        ? drillingSettings.drillingZones
        : defaultDrillingZones
    }
  })

  const submitForm = (data: {
    drillingZones: DrillingZone[]
    drillingPositions: DrillingPosition[]
  }) => {
    mutate({
      drillingZones: data.drillingZones,
      drillingPositions: data.drillingPositions,
      kilnUpmId: drillingSettings.kilnUpmId,
      plantUpmId: drillingSettings.plantUpmId
    })
  }

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(submitForm)}>
          <div className="flex justify-end">
            <Button type="submit" data-test-id="drilling_positions_save_btn">
              {t('common.save')}
            </Button>
          </div>
          <div className="mb-24px">
            <DrillingPositions />
          </div>
          <DrillingZones kilnConfig={kilnConfig} />
        </form>
      </FormProvider>
    </div>
  )
}
